export const KEYCLOAK_CLIENT_ID = 'websearch-backend-spring-boot-client';

/** Short-lived cookie. The next signOut clears the app session and skips Keycloak logout. */
export const SKIP_KC_LOGOUT_COOKIE = 'skip-keycloak-logout';
